import {
  FPlusDefaultFontWidth,
  FPlusDefaultFormattingWidth,
} from '@festina-life/fplus-monaco'
import { useResizeObserver } from '@festina-life/ui/hooks'
import { type RefObject, useMemo } from 'react'

export const DEFAULT_FPLUS_CONTAINER_PADDING = 16

export const pixelsToFPlusCharacters = (pixels: number) =>
  Math.floor(pixels / FPlusDefaultFontWidth) ?? FPlusDefaultFormattingWidth

export type FPlusWidthProps = {
  ref: RefObject<HTMLElement | null>
  paddingWidth?: number
}

export const useContainerWidthInFPlusCharacters = ({
  ref,
  paddingWidth = DEFAULT_FPLUS_CONTAINER_PADDING,
}: FPlusWidthProps) => {
  const { width: containerWidth } = useResizeObserver(ref) ?? {}

  return useMemo(() => {
    if (containerWidth && containerWidth !== 0) {
      return pixelsToFPlusCharacters(containerWidth - paddingWidth)
    }

    return 0
  }, [containerWidth, paddingWidth])
}
